import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class EventService extends BaseService {

    static url = "events";
    static apis = {
        getAll: { path: this.url, method: "get" },
        getLength: {path: this.url + '/length', method:"get"},
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("events");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: EventService.apis.getAll.path,
                    method: EventService.apis.getAll.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getEventsLength(){
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: EventService.apis.getLength.path,
                    method: EventService.apis.getLength.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default EventService;